import { FormattedDate } from 'gatsby-plugin-react-intl';
import PropTypes from 'prop-types';

import RichText from '../../Core/RichText';

import { Category, Content, StyledLink } from './styles';

const ContentItem = ({ currentArticles }) => {
  if (!currentArticles) return false;
  return (
    <Category>
      <Content className="no-bullets">
        {currentArticles.map(
          ({ node: { id, headline, pageSlug, publishDate } }) => (
            <li key={id}>
              {publishDate && (
                <p>
                  <strong>
                    <FormattedDate
                      value={new Date(publishDate.replace(/-/g, '/'))}
                      year="numeric"
                      month="long"
                      day="2-digit"
                    />
                  </strong>
                </p>
              )}
              <StyledLink to={`/media-centre/${pageSlug}`}>
                <RichText document={headline} />
              </StyledLink>
            </li>
          ),
        )}
      </Content>
    </Category>
  );
};

ContentItem.propTypes = {
  currentArticles: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default ContentItem;
